import { GET_SKILLS, GET_SKILLS_COURSES } from '../actionTypes';

const getInitialState = () => ({
  skills: {},
});

const reducer = (state = getInitialState(), action) => {
  switch (action.type) {
    case GET_SKILLS: {
      const { skills } = action.payload;
      return {
        ...state,
        skills,
      };
    }
    case GET_SKILLS_COURSES: {
      const { skillsCourses } = action.payload;
      return {
        ...state,
        skillsCourses,
      };
    }

    default:
      return state;
  }
};

export default reducer;
